import React, { useState, useEffect } from "react";
import styles from "./tabs.module.css";

export const Tabs = ({ children, activeTab: externalActiveTab, onTabChange }) => {
  const [internalActiveTab, setInternalActiveTab] = useState(0);
  const [tabTitles, setTabTitles] = useState([]);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  // Use external activeTab if provided, otherwise use internal state
  const activeTab = externalActiveTab !== undefined ? externalActiveTab : internalActiveTab;

  useEffect(() => {
    const titles = React.Children.map(children, (child) => child.props.title);
    setTabTitles(titles);
  }, [children]);

  useEffect(() => {
    // Force resize after mount to fix chart sizing
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 100); // slight delay to allow layout to settle
  }, []);

  const handleTabClick = (index) => {
    if (index === activeTab) {
      setIsExpanded(false);
      return;
    }

    setIsTransitioning(true);
    setTimeout(() => {
      if (onTabChange) {
        // If external control is provided, call the callback
        onTabChange(index);
      } else {
        // Otherwise, use internal state
        setInternalActiveTab(index);
      }
      setIsTransitioning(false);
      setIsExpanded(false);
    }, 200); // match the CSS fade duration
  };

  return (
    <div>
      <div className={`${styles.tabSidebar} ${isExpanded ? styles.expanded : ""}`}>
        <div className={styles.tabHandle} onClick={() => setIsExpanded(!isExpanded)}>
          <span className={styles.handleIcon}>⋮⋮</span>
        </div>
        <div className={styles.tabPanel}>
          {tabTitles.map((title, index) => (
            <button
              key={index}
              className={`${styles.tabButton} ${activeTab === index ? styles.tabActive : ""}`}
              onClick={() => handleTabClick(index)}
            >
              {title}
            </button>
          ))}
        </div>
      </div>
      <div className={styles.tabContentWrapper}>
        <div className={`${styles.tabContentFade} ${!isTransitioning ? styles.show : ""}`}>
          {React.Children.toArray(children)[activeTab]}
        </div>
      </div>
    </div>
  );
};
